import React, { forwardRef } from 'react';
import { InfoIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { cx } from 'linaria';
import { AdLabelIconWrapperStyles } from '../styles';
import { AdLabelIconProps } from '../types';

export const AdLabelIcon = forwardRef<HTMLDivElement, AdLabelIconProps>((props, ref) => {
  const { variant, className, ...wrapperProps } = props;

  return (
    <div
      data-qa="ad-label-icon"
      className={cx(AdLabelIconWrapperStyles, className)}
      ref={ref}
      {...wrapperProps}>
      {variant === 'icon' && <InfoIcon type="outline" size="m" color="text-minor" />}
      {variant === 'text' && <Typography variant="caption">реклама</Typography>}
      {variant === 'stretch-banner-text' &&
        <Typography variant="mini" color="secondary-black" size="regular">РЕКЛАМА</Typography>}
    </div>
  );
});
